import find from "lodash/find";

import {Part} from "./part";
import {PartMenuType} from "../../../visComponents/constants";
import {IntermediatePart} from "./intermediatePart";

export default class GlobalShadow extends Part {
  static id = 'Global Shadow';

  constructor() {
    super(true, false, PartMenuType.Simple);
    this.partId = 'global_shadow';
    this.menuType = PartMenuType.Simple;
    this.partName = 'Global Shadow';
  }

  load(dbFeature) {
    let part = null;
    switch (dbFeature.groupName) {
      case "Global Shadow":
        part = new GlobalShadowBody();
        break;
    }
    if (part) {
      part.getParent = () => this;
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      part.load(dbFeature);
      return true
    }
    return false
  }

  setLayers(layout) {
    const layers = [];
    if (this.activeFeature) {
      this.activeFeature.setLayers(layout);
      this.activeFeature.layer.addTo(layers);
    }
    return layers;
  }

  setDefault() {
    this.activeFeature = this.features[0];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.setZIndex(zIndexes);
    }
  }

}

class GlobalShadowBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);

    this.partName = 'Global Shadow Body';
  }

  load(dbFeature) {
    super.load_.call(this.getParent(), dbFeature, this, false);
  }

  setLayers(layout) {
    // const s3Binding = find(this.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this)});
    let s3Binding = find(this.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this), layout: layout.getCurrentLayoutAbbreviation()});
    if (!s3Binding) {
      s3Binding =  find(this.dbFeature.s3Bindings, {entityID: this.featureDefinitionId(this)});
    }
    this.layer.fromS3Binding(s3Binding);
  }

  setDefault() {
    this.activeFeature = this.features[0];
  }

  setZIndex(zIndexes) {
    if(zIndexes)
      this.layer.zIndex = zIndexes.Global_Shadow_Overlay;
  }
}
